var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['flex flex-col w-full relative', _vm.cl]},[(_vm.hasLabel)?_c('label',{class:['mb-1 hidden lg:block', _vm.labelFont],attrs:{"for":_vm.$attrs.label}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.$attrs.required)?_c('span',{staticClass:"text-red-default"},[_vm._v(" *")]):_vm._e()]):_vm._e(),_c('input',_vm._g(_vm._b({ref:"input",class:[
      'input  ',
      _vm.size,
      _vm.inverted ? 'bg-white' : '',
      _vm.hasLabel
        ? 'placeholder-secondary-dark placeholder-opacity-100 lg:placeholder-opacity-0'
        : '',
    ],attrs:{"type":_vm.type,"id":_vm.$attrs.label,"placeholder":_vm.placeholder,"autocomplete":"off","spellcheck":"false","required":_vm.$attrs.required},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners)),(
      typeof this.$attrs.clearable !== 'undefined' &&
      _vm.value !== '' &&
      this.$attrs.label !== 'date' &&
      this.hasLabel
    )?_c('BaseIcon',{staticClass:"cursor-pointer absolute right-0 hover:text-primary",attrs:{"id":"1st icon","icon":"close"},on:{"click":function($event){return _vm.$emit('update', '')}}}):_vm._e(),(typeof this.$attrs.clearable !== 'undefined' && _vm.value !== '' && !this.hasLabel)?_c('BaseIcon',{class:[
      'cursor-pointer absolute hover:text-primary',
      _vm.$attrs.size === 'sm'
        ? 'right-1 top-2'
        : _vm.$attrs.size === 'lg'
        ? 'right-2 top-4 text-lg'
        : 'right-1 top-3',
    ],attrs:{"id":"placeholder-clear","icon":"close"},on:{"click":function($event){return _vm.$emit('update', '')}}}):_vm._e(),(
      typeof this.$attrs.clearable !== 'undefined' && _vm.value !== '' && this.$attrs.label === 'date'
    )?_c('BaseIcon',{staticClass:"cursor-pointer absolute right-0 hover:text-primary",attrs:{"id":"2nd icon","icon":"close"},on:{"click":function($event){return _vm.$emit('clear')}}}):_vm._e(),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }